import React, { useEffect, useState } from 'react';
import $ from 'jquery-slim';
import { get } from 'lodash';
import { Outlet } from 'react-router-dom';
import { useDispatch } from "react-redux";

import { makeProfileData } from "../../actions/storage";
import Header from './Header';
import Footer from './Footer';
import Spinner from '../../components/Spinner';
import AsyncGet from '../../components/Materials/AsyncGet';

import "../../assets/css/style.css";
import style from "./style.module.css"
import ChangePassword from './ChangePassword';

const Layout = () => {
    const dispatch = useDispatch();
    const [dimesions, setDimensions] = useState({ height: 0, winWidth: window.innerWidth, winHeight: window.innerHeight });

    useEffect(() => {
        function updateDimensions() {
            setDimensions({
                winWidth: $(window).width(),
                winHeight: $(window).height() - $(`header`).outerHeight(),
            });
        }
        window.addEventListener('resize', updateDimensions);
        updateDimensions();
        return () => {
            window.removeEventListener('resize', updateDimensions);
        }
    }, []);

    return (
        <>
            <div className='contents'>
                <AsyncGet
                    url="/account"
                    permissionText={false}
                    loadOnMount={true}
                    onFetch={({ data }) => {
                        if (get(data, 'id')) {
                            dispatch(makeProfileData(data))
                        }
                    }}
                    render={({ loaded, fetching, data, loadFromAPI }) => {
                        return (
                            <>
                                <Header context={{ winHeight: dimesions.winHeight }} />
                                {loaded === false && fetching === true &&
                                    <div className={`${style.content}`}>
                                        <Spinner size="large" />
                                    </div>
                                }
                                {loaded === true && fetching === false &&
                                    <>
                                        <Outlet context={{ height: dimesions.height, winWidth: dimesions.winWidth, winHeight: dimesions.winHeight }} />
                                        <ChangePassword userData={data} reloadUser={loadFromAPI} />
                                    </>
                                }
                            </>
                        )
                    }}
                />
            </div>
            <Footer />
        </>
    )
}

export default Layout;